import { useEffect, useState } from 'react';

import { client, useErrorNotifications } from 'core/http';
import { MaintenanceAction } from 'core/types/maintenanceAction';

export default function useMaintenanceActions(id: number) {
  const showErrorNotification = useErrorNotifications();
  const [actions, setActions] = useState<MaintenanceAction[]>([]);

  useEffect(() => {
    client()
      .get(`maintenances/${id}/actions`)
      .then(response => setActions(response.data.data))
      .catch(showErrorNotification);
  }, [id, showErrorNotification]);

  return actions;
}
